import React from 'react';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore
import DHPaper from "@digital-hig/mui/Paper";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Popup: React.FC<PopupProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <DHBox
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'var(--backdrop-60, hsla(0, 0%, 0%, 0.6))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={onClose}
    >
      <DHBox
        sx={{
          width: { xs: '90%', sm: '800px' },
          maxWidth: '800px',
          height: '407px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          pb: 0,
          outline: 'none'
        }}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <DHPaper
          elevation={0}
          sx={{
            p: 3,
            pb: 0,
            borderRadius: 2,
            backgroundColor: 'background.paper',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {children}
        </DHPaper>
      </DHBox>
    </DHBox>
  );
};
